// components/MediaPlaceholder.jsx
// Stand-in for images and Remotion motion graphics that haven't been
// produced yet. Renders a bordered, labeled box at the given aspect ratio so
// layout is correct now and the real asset can drop in later without any
// layout changes.

export default function MediaPlaceholder({
  label,
  aspect = "16/9",
  minHeight,
  dark = false,
  style = {},
  className = "",
}) {
  return (
    <div
      className={`media-placeholder ${className}`}
      style={{
        aspectRatio: aspect,
        minHeight,
        border: `1.5px dashed ${dark ? "rgba(245,242,236,0.35)" : "rgba(26,26,46,0.28)"}`,
        background: dark ? "rgba(245,242,236,0.04)" : "rgba(26,26,46,0.03)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: 20,
        boxSizing: "border-box",
        ...style,
      }}
    >
      <span
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          textAlign: "center",
          lineHeight: 1.7,
          color: dark ? "rgba(245,242,236,0.55)" : "rgba(26,26,46,0.5)",
        }}
      >
        {label}
      </span>
    </div>
  );
}
